import { render, staticRenderFns } from "./catalogue_details.vue?vue&type=template&id=1f827020"
import script from "./catalogue_details.vue?vue&type=script&lang=js"
export * from "./catalogue_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports